import $ from 'jquery';

$.addInit(function(context){
	var base = '.b-cardCase';
	$(base, context).each(function(){
		var component = $(this);
		var content = component.find(base + '-content')
		var dropdown = component.find('.b-cardCaseInfo');
		var body = dropdown.find('.b-cardCaseInfo-body');
		var bodyContent = dropdown.find('.b-cardCaseInfo-body').data('load');
		var close = dropdown.find('.b-cardCaseInfo-close');
		var isActive = false;
		var overlay = $('<div>', {
			'class': 'b-overlay'
		});

		function setActive(value) {
			dropdown.toggleClass('m-active', value);
			$(document)[value ? 'on' : 'off']('click touchstart', closeHandler);

			if (value) {
				overlay.appendTo('body')
			} else {
				overlay.detach()
			};

			isActive = value;
		}

		function openHandler(e) {
			e.preventDefault();

			setTimeout(function() {
				setActive(true);
			});
		}

		function closeHandler(e) {
			if ($(e.target).closest(dropdown).length === 0) {
				setActive(false);
			}
		}

		content.on('click', function(e) {
			openHandler(e);

			if (bodyContent) {
				body.load(bodyContent);
			}
		});

		close.on('click', function(e) {
			setTimeout(function() {
				setActive(false);
			});
		});
	});
});
